import { $axios, dealWithErrors, dealWithSuccess } from '../import/http'
import store from '@/store'
import filter from '../import/filter'

const filteredKeys = [
  {
    path: '',
    loop: false,
    keys: [
      {
        key: 'pmt_id',
        type: 'int',
      },
      {
        key: 'pmt_is_active',
        type: 'bool',
      },
      {
        key: 'pmt_is_cash_on_delivery',
        type: 'bool',
      },
    ],
  },
  {
    path: 'current_history.',
    loop: false,
    keys: [
      {
        key: 'pty_add_percentage',
        type: 'float',
      },
      {
        key: 'pty_price',
        type: 'float',
      },
      {
        key: 'pty_date_from',
        type: 'date',
      },
      {
        key: 'languages[0].phe_name',
        type: 'string',
      },
    ],
  },
]

export default {
  namespaced: true,
  state: {
    items: [],
    detail: {
      current_history: {
        languages: [],
      },
    },
  },
  mutations: {
    SET_ITEMS(state, items) {
      state.items = items
    },
    SET_CURRENT(state, items) {
      const index = state.items.indexOf(state.items.find(x => x.lge_id === store.getters['language/active']))
      if (index !== -1) {
        state.items.splice(index, 1)
      }
      state.items.push(items)
    },
    SET_CURRENT_DETAIL(state, item) {
      const index = state.detail.current_history.languages.indexOf(state.detail.current_history.languages.find(x => x.lge_id === store.getters['language/active']))
      const oldLang = state.detail.current_history.languages
      const newItem = {
        lge_id: store.getters['language/active'],
        phe_name: item.current_history.languages.length > 0 ? item.current_history.languages[0].phe_name : undefined,
      }
      state.detail = Object.assign({}, item)
      state.detail.current_history.languages = oldLang
      if (index !== -1) {
        state.detail.current_history.languages.splice(index, 1)
      }
      state.detail.current_history.languages.push(newItem)
    },
    UPDATE_STATE(state, payload) {
      state.items.forEach((value, key) => {
        for (let i = 0; i < value.data.length; i++) {
          if (payload.items.includes(value.data[i].pmt_id)) {
            state.items[key].data[i].pmt_is_active = payload.activated
          }
        }
      })
    },
  },
  actions: {
    getList({ commit }) {
      return new Promise((resolve, reject) => {
        $axios.get('/payment/lang/' + store.getters['language/active'], {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(response => {
          commit('SET_CURRENT', response.data)
          resolve(response)
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    getOne({ commit }, id) {
      return new Promise((resolve, reject) => {
        $axios.get('/payment/' + id + '/lang/' + store.getters['language/active'], {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(response => {
          commit('SET_CURRENT_DETAIL', response.data)
          resolve(response)
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    deactivate({ commit }, items) {
      return new Promise((resolve, reject) => {
        $axios.delete('/payment', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
          data: { data: items.map(x => { return { pmt_id: x } }) },
        }).then(() => {
          commit('UPDATE_STATE', { items: items, activated: false })
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Deaktivace proběhla v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    post({ commit }, items) {
      return new Promise((resolve, reject) => {
        $axios.post('/payment', { data: items }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(() => {
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Vytvoření proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    put({ commit }, { id, item }) {
      return new Promise((resolve, reject) => {
        $axios.put('/payment/' + id, { data: item }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then((response) => {
          resolve()
          dealWithSuccess({ data: response.data.data, message: 'OK!', description: 'Upravení proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    activate({ commit }, id) {
      return new Promise((resolve, reject) => {
        $axios.patch('/payment/' + id, {}, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then((response) => {
          commit('UPDATE_STATE', { items: id, activated: true })
          resolve()
          dealWithSuccess({ data: response.data.data, message: 'OK!', description: 'Aktivace proběhla v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
  },
  getters: {
    allItems: state => state.items,
    currentLanguage: (state) => (searchText = '') => {
      const activeItems = state.items.filter(x => x.lge_id === store.getters['language/active'])
      const currentItems = store.getters['language/active'] !== null && activeItems.length !== 0 && activeItems[0].data !== undefined ? activeItems[0].data : []
      if (searchText.length > 0) {
        return filter.methods.filterItems(currentItems, filteredKeys, searchText)
      }
      return currentItems
    },
    byLanguage: (state) => (searchText = '', language) => {
      const activeItems = state.items.filter(x => x.lge_id === language)
      return language !== null && activeItems.length !== 0 && activeItems[0].data !== undefined ? activeItems[0].data : []
    },
    currentLanguageDetail: (state) => {
      return state.detail.current_history.languages !== undefined ? state.detail.current_history.languages.find(x => x.lge_id === store.getters['language/active']) : undefined
    },
    getDetail: (state) => {
      return state.detail
    },
  },
}
